// M2wApi.js - varianta initiala

const stagingPattern = /staging-\S+.map2web.(eu|ro)/;
const ipPattern = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;

export default class M2wApi {
  static domain = M2wApi.parseDomain();
  static host_address = M2wApi.parseApiHostname();
  static base_address = M2wApi.host_address + "apiv2/project/";

  // static async get_project_info() {
  //   const response = await fetch(M2wApi.base_address + M2wApi.domain);
  //   return await response.json();
  // }
  static async get_project_info() {
    const response = await fetch(M2wApi.base_address + M2wApi.domain, {cache: "no-store"});

    const data = await response.json();

    console.log("[PROJECT API] Răspuns complet:", data);
    console.log("[PROJECT API] SF:", data.sf_basemap);
    console.log("[PROJECT API] layerSF:", data.sf_basemap?.layerSF);

    return data;
  }

  // static async get_project_pois(lang) {
  //   let url = M2wApi.base_address + M2wApi.domain + "/pois";
  //   if (lang) url += `?lang=${lang}`;

  //   const response = await fetch(url);

  //   return await response.json();
  // }

  // static async get_single_poi(id, lang, parent) {
  //   let url = M2wApi.base_address + M2wApi.domain + `/pois/${id}?`;
  //   if (lang) url += `lang=${lang}&`;
  //   if (parent) url += `parent=${parent}`;

  //   const response = await fetch(url);
  //   return await response.json();
  // }
  static async get_single_poi(id, lang, parent) {
    let url = M2wApi.base_address + M2wApi.domain + `/pois/${id}?`;

    if (lang) url += `lang=${lang}&`;
    if (parent) url += `parent=${parent}&`;

    // cache buster
    url += `_ts=${Date.now()}`;

    console.log("[get_single_poi URL]", url);

    const response = await fetch(url, {
      cache: "no-store"
    });

    const data = await response.json();

    console.log("[get_single_poi RESPONSE]", {
      id,
      add_info: data?.contact?.add_info,
      data
    });
    console.log("POI complet:", data);
    console.log("360 URL:", data.url_360);
    console.log("Info:", data.info);

    return data;
  }

  static async get_project_pois(lang) {
    let url = M2wApi.base_address + M2wApi.domain + "/pois";

    const params = new URLSearchParams();

    if (lang) {
      params.set("lang", lang);
    }

    params.set("_ts", Date.now());

    url += `?${params.toString()}`;

    const response = await fetch(url, {
      cache: "no-store"
    });

    return await response.json();
  }
  static async get_streets() {
    const response = await fetch(M2wApi.base_address + M2wApi.domain + "/streets");
    return await response.json();
  }

  static async get_single_street(id) {
    const response = await fetch(M2wApi.base_address + M2wApi.domain + `/streets/${id}`);
    return await response.json();
  }

  static async get_search_results(term, page, pagesize, location, lang) {
    const l = location.split(",");
    let url =
      M2wApi.base_address + M2wApi.domain + `/search?q=${term}&page=${page}&count=${pagesize}&x=${l[0]}&y=${l[1]}`;
    if (lang) url += `&lang=${lang}`;
    const response = await fetch(url);
    return await response.json();
  }
  static async get_closest_poi(coordinates, lang) {
    let url = M2wApi.base_address + M2wApi.domain + `/near_me?x=${coordinates[0]}&y=${coordinates[1]}&radius=1000`;
    if (lang) url += `&lang=${lang}`;
    const response = await fetch(url);
    return await response.json();
  }

  static async get_wfs_feature(folder_id, bbox, lang) {
    let url = M2wApi.base_address + M2wApi.domain + `/wfs/${folder_id}?bbox=${bbox.join(",")}&lang=${lang}`;
    console.log(url);
    const response = await fetch(url);
    if (!response.ok) throw new Error(response.status.toString(10));
    return await response.json();
  }

  static async get_project_events(lang) {
    const tree = await M2wApi.get_project_pois(lang);

    function getName(node) {
      return typeof node?.name === "string" ? node.name : node?.name?.name || "";
    }

    function findEventsFolder(node) {
      if (!node) return null;

      const name = getName(node);

      if (
        name === "Events Calendar" ||
        name === "Calendar evenimente" ||
        name === "Calendar Evenimente" ||
        name === "Veranstaltungskalender" ||
        name === "Eseménynaptár"
      ) {
        return node;
      }

      if (node.children?.length) {
        for (const child of node.children) {
          const found = findEventsFolder(child);
          if (found) return found;
        }
      }

      return null;
    }

    const eventsFolder = findEventsFolder(tree);

    if (!eventsFolder) {
      console.warn("Categoria Calendar evenimente nu a fost găsită.");
      return [];
    }

    const eventsFolderId = eventsFolder.id;

    const items = (eventsFolder.children || []).filter(child => child.type === "item");

    const poiEntries = await Promise.all(
      items.map(async item => {
        try {
          const poi = await M2wApi.get_single_poi(item.id, lang, eventsFolderId);

          return {
            poi,
            parent_id: eventsFolderId
          };
        } catch (error) {
          console.error("Eroare la încărcarea POI-ului:", item.id, error);

          return null;
        }
      })
    );

    const events = [];

    poiEntries.forEach(entry => {
      if (!entry?.poi?.events?.length) return;

      const {poi, parent_id} = entry;

      poi.events.forEach((event, eventIndex) => {
        if (event.enabled === false) return;

        const eventId = event.id ?? event.event_id ?? event.pk ?? `event-${parent_id}-${poi.id}-${eventIndex}`;

        events.push({
          ...event,
          id: eventId,
          event_id: eventId,
          event_index: eventIndex,
          poi,
          poi_id: poi.id,
          poi_name: poi.name,
          geom: poi.geom,
          marker: poi.marker,
          parent_id,
          cover: event.cover || event.cover_image || poi.cover
        });
      });
    });

    return events.sort((a, b) => new Date(a.date_from) - new Date(b.date_from));
  }

  static async get_single_event(eventId, lang, poiId, parent) {
    if (poiId) {
      const poi = await M2wApi.get_single_poi(poiId, lang, parent);

      const eventIndex = poi.events?.findIndex((event, index) => {
        const currentEventId = event.id ?? event.event_id ?? event.pk ?? `event-${parent}-${poi.id}-${index}`;

        return String(currentEventId) === String(eventId);
      });

      if (eventIndex == null || eventIndex < 0) {
        console.error("Evenimentul nu a fost găsit:", {
          eventId,
          poiId,
          parent,
          events: poi.events
        });

        return null;
      }

      const event = poi.events[eventIndex];

      const normalizedEventId = event.id ?? event.event_id ?? event.pk ?? `event-${parent}-${poi.id}-${eventIndex}`;

      return {
        ...event,

        id: normalizedEventId,
        event_id: normalizedEventId,
        event_index: eventIndex,

        poi,
        poi_id: poi.id,
        poi_name: poi.name,

        parent_id: parent || poi.parent?.id || poi.parent_id,

        geom: poi.geom,
        marker: poi.marker,

        cover: event.cover || event.cover_image || poi.cover
      };
    }

    const events = await M2wApi.get_project_events(lang);

    return events.find(event => String(event.event_id) === String(eventId)) || null;
  }

  static parseDomain() {
    let hostname = window.location.hostname;
    if (stagingPattern.test(hostname)) return hostname.substr("staging-".length);
    if (!ipPattern.test(hostname) && hostname !== "localhost") return hostname;

    // Fallback
    // return "cs-test.map2web.eu";
    // return "st-poelten.map2web.eu";
    // return "suncuius.map2web.eu";
    // return "arad-test.map2web.eu";
    // return "cluj-county-test.map2web.eu";
    // return "bucovina.map2web.eu";
    // return "sibiu-city.map2web.eu";
    // return "test_laura3.map2web.eu";
    //  return "test_laura.map2web.eu";
    // return "st-poelten-test.map2web.eu";
    // return "st-poelten-test.map2web.eu";
    // return "demo3.map2web.eu";
    // return "achau.map2web.eu";
    // return "jucu.map2web.eu";
    // return "dolj-county.map2web.eu";
    // return "rennraderlebnis.map2web.eu";
    // return "bad-ischl.map2web.eu"
    // return "iz-noe-sued.map2web.eu";
    // return "wiener-neustadt.map2web.eu";
    // return "leoben.map2web.eu";
    // return "arad-city.map2web.eu"
    // return "livada.map2web.eu"
    // return "maramures.map2web.eu"
    // return "ardud.map2web.eu";
    // return "mangalia-city.map2web.eu";
    // return "tara-dornelor-test.map2web.eu";
    // return "maramures-turism.map2web.eu";
    // return "campulung-moldovenesc-turism.map2web.eu"
    // return "sangeorzbai-city.map2web.eu"
    return "vatra-dornei-turism.map2web.eu"
    // return "vatra-dornei-city.map2web.eu"
    // return "krems.map2web.eu";
  }
  //   static parseDomain() {
  //   const hostname = window.location.hostname;

  //   if (stagingPattern.test(hostname)) {
  //     return hostname.substring("staging-".length);
  //   }

  //   // Dezvoltare locală
  //   if (
  //     hostname === "localhost" ||
  //     hostname === "127.0.0.1" ||
  //     hostname === "::1" ||
  //     ipPattern.test(hostname)
  //   ) {
  //     return "st-poelten.map2web.eu";
  //     // return "cs-test.map2web.eu";
  //   }

  //   // Pe server folosește domeniul real
  //   return hostname;
  // }
  // // local
  // static parseApiHostname() {
  //   let hostname = window.location.hostname;

  //   if (
  //     hostname === "localhost" ||
  //     hostname === "127.0.0.1" ||
  //     hostname === "::1" ||
  //     ipPattern.test(hostname)
  //   ) {
  //     return "http://localhost:7005/";

  //   }

  //   return "https://map.map2web.eu/";
  // }
  static parseApiHostname() {
    // let hostname = window.location.hostname;
    // if (ipPattern.test(hostname) || hostname === "localhost") {
    //   return "http://localhost:5001/";
    // }
    // if (hostname === "localhost" || hostname === "127.0.0.1" || hostname === "::1" || ipPattern.test(hostname)) {
    // // return "http://localhost:7005/";
    // return "http://172.16.1.221:5001/";
    // }

    // return "http://172.16.20.127:5001/";
    return "https://map.map2web.eu/";
  }
}
